import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// =====================================
// BUSINESS LIST
// =====================================
export async function getBusinessList(buss_user, buss_status, page = 0) {
  try {
    const fd = new FormData();

    fd.append("buss_user", buss_user || "");
    fd.append("buss_status", buss_status || "");
    fd.append("page", page);

    const response = await axios.post(
      `${apiBaseUrl}businessapis/getList`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;

  } catch (error) {
    console.error("getBusinessList error:", error);
    return { status: false, type: "danger", success: "Failed to load businesses" };
  }
}

// =====================================
// ADD / EDIT BUSINESS
// =====================================
export async function saveBusiness(payload) {
  try {
    const fd = new FormData();

    Object.keys(payload).forEach(key => {
      fd.append(key, payload[key] ?? "");
    });

    const response = await axios.post(
      `${apiBaseUrl}businessapis/save_business`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;

  } catch (error) {
    console.error("saveBusiness error:", error);
    return { status: false, type: "danger", success: "Failed to save business" };
  }
}

// =====================================
// DELETE BUSINESS
// =====================================
export async function deleteBusiness(buss_id) {
  try {
    const fd = new FormData();

    fd.append("buss_id", buss_id);

    const response = await axios.post(
      `${apiBaseUrl}businessapis/delete_business`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;

  } catch (error) {
    console.error("deleteBusiness error:", error);
    return { status: false, type: "danger", success: "Failed to delete business" };
  }
}